/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiRequisition, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of RequisitionsController.
 */
export class RequisitionsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /requisitions:prefill
     */
    public createPrefilled(): Promise<Result<ApiRequisition>> {
        return this.http.post<Result<ApiRequisition>, undefined>('/requisitions:prefill', undefined);
    }

    /**
     * Calls POST /requisitions/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiRequisition>>> {
        return this.http.post<Result<LockedContextDto<ApiRequisition>>, undefined>(`/requisitions/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /requisitions/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiRequisition>> {
        return this.http.post<Result<ApiRequisition>, undefined>(`/requisitions/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /requisitions/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiRequisition[]>> {
        return this.http.post<Result<ApiRequisition[]>, string[]>('/requisitions/locks', ids);
    }

    /**
     * Calls POST /requisitions/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/requisitions/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /requisitions/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/requisitions/${primaryId}/locks`);
    }

    /**
     * Calls GET /requisitions/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiRequisition>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiRequisition>>(`/requisitions/${primaryId}`, query);
    }

    /**
     * Calls POST /requisitions
     */
    public add(dto: ApiRequisition): Promise<Result<ApiRequisition>> {
        return this.http.post<Result<ApiRequisition>, ApiRequisition>('/requisitions', dto);
    }

    /**
     * Calls PUT /requisitions/{primaryId}
     */
    public update(dto: ApiRequisition, primaryId: string): Promise<Result<ApiRequisition>> {
        return this.http.put<Result<ApiRequisition>, ApiRequisition>(`/requisitions/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /requisitions
     */
    public putRange(dtos: ApiRequisition[]): Promise<Result<ApiRequisition[]>> {
        return this.http.patch<Result<ApiRequisition[]>, ApiRequisition[]>('/requisitions', dtos);
    }

    /**
     * Calls DELETE /requisitions/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/requisitions/${primaryId}`);
    }

    /**
     * Calls POST /requisitions:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiRequisition>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiRequisition>>, ListRequestWithIds>('/requisitions:batch', listRequest, query);
    }

    /**
     * Calls POST /requisitions:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiRequisition>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiRequisition>>, ListRequest>('/requisitions:query', listRequest, query);
    }

    /**
     * Calls GET /requisitions:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiRequisition>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiRequisition>>>('/requisitions:query', query);
    }
}
